__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "portalHost";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@okta/okta-react", "3.0.7", () => (Promise.all([__webpack_require__.e(6835), __webpack_require__.e(8816)]).then(() => (() => (__webpack_require__(96835))))));
			register("@playgami/portal-logs", "1.5.0", () => (__webpack_require__.e(9657).then(() => (() => (__webpack_require__(89657))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(7918).then(() => (() => (__webpack_require__(67918))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(70316))), 1);
			register("react-redux", "9.2.0", () => (__webpack_require__.e(1190).then(() => (() => (__webpack_require__(1190))))));
			register("react-router-dom", "5.3.4", () => (__webpack_require__.e(1962).then(() => (() => (__webpack_require__(31962))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(22155))), 1);
			register("redux", "5.0.1", () => (() => (__webpack_require__(90805))), 1);
			initExternal(77271);
			initExternal(70185);
			initExternal(4783);
			initExternal(78701);
			initExternal(28235);
			initExternal(96289);
			initExternal(12084);
			initExternal(66474);
			initExternal(57093);
			initExternal(60612);
			initExternal(93543);
			initExternal(23904);
			initExternal(88799);
			initExternal(73731);
			initExternal(92327);
			initExternal(78171);
			initExternal(98412);
			initExternal(74453);
			initExternal(12851);
			initExternal(25725);
			initExternal(41615);
			initExternal(87924);
			initExternal(98104);
			initExternal(3489);
			initExternal(71989);
			initExternal(12201);
			initExternal(12113);
			initExternal(97308);
			initExternal(19183);
			initExternal(37558);
			initExternal(89078);
			initExternal(48940);
			initExternal(91818);
			initExternal(51274);
			initExternal(15822);
			initExternal(52833);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};